import { formatPrice } from '@weft/services';
import type { Currency, RevenueBreakdown } from '@weft/types';
import cn from 'classnames';
import React from 'react';

type LightInvoiceSummaryProps = {
  revenueBreakdown: RevenueBreakdown;
  isPdf?: boolean;
  currency: Currency;
};

export const LightInvoiceSummary:React.FC<LightInvoiceSummaryProps> = ({
  revenueBreakdown,
  isPdf,
  currency,
}) => {
  const { total, subtotal, discount, creditsUsed, tax } = revenueBreakdown;

  return (
    <section className="w-full pt-8">
      <div className="border-b-line border-b px-6">
        <div className={cn('font-normal space-y-3.5 py-4 ')}>
          <div className="flex items-center justify-between text-base text-black">
            <div>Sub Total</div>
            <div>{formatPrice(subtotal, currency)}</div>
          </div>
          <div className="flex items-center justify-between text-base text-black">
            <div>Discount</div>
            <div>{`-${formatPrice(discount, currency)}`}</div>
          </div>
          <div className="flex items-center justify-between text-base text-black">
            <div>Tax</div>
            <div>{`${formatPrice(tax, currency)}`}</div>
          </div>
          { creditsUsed > 0 && (
            <div className="flex items-center justify-between text-base text-black">
              <div>Paid with credits</div>
              <div>{`-${formatPrice(creditsUsed, currency)}`}</div>
            </div>
          )}
        </div>
      </div>

      <div className={cn('border-b-line flex items-center justify-between border-b px-9', isPdf ? 'pb-4' : 'py-4')}>
        <div className="text-xl font-bold text-black">Amount Due</div>
        <div className='text-xl font-bold text-black'>
          {formatPrice(total, currency)}
        </div>
      </div>
    </section>
  );
};